import { Backdrop, CircularProgress } from '@mui/material';

type Props = {
  loading: boolean;
};

export const LoaderFullScreen = ({ loading }: Props) => {
  if (!loading) return null;
  return (
    <Backdrop
      sx={{
        backgroundColor: 'rgba(0,0,0,0.3)',
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={loading}
    >
      <CircularProgress />
    </Backdrop>
  );
};
